import React from "react";
import { Checkbox, Form, Input, Select } from "antd";

import { countries } from "../../../Utils/common";
import UploadAvatar from "../../createDeal/forms/UploadAvatar";
import { sectorOptions } from "../../createDeal/forms/GeneralInformationForm/sectorOptions";
import "./ProjectBasicsFields.scss";

// The listing flags from the standard project form, which decide the pages a
// project is listed on.
export const LISTING_OPTIONS = [
    { value: "isCommercialDashboard", label: "Commercial Dashboards" },
    { value: "isQuantumTechProducts", label: "QuantumTech Products" },
    { value: "isHealthTechProducts", label: "HealthTech Products" },
    { value: "isLongevityProducts", label: "Longevity Products" },
    { value: "isPartnerships", label: "Partnerships" },
    { value: "isGCCProject", label: "GCC Projects" },
    { value: "isFemtechAnalyticsProject", label: "Femtech Analytics" },
    { value: "isEcosystemProject", label: "Ecosystem Projects" },
    { value: "isPartnershipsSandbox", label: "Partnerships Sandbox" },
    { value: "isBizdevSandbox", label: "Business Development Sandbox" },
];

const countryOptions = countries.map((country) => ({ value: country, label: country }));

/**
 * Serialises the basics the way the standard project form sends them: sector
 * as a JSON array, every listing flag as "true"/"false", the logo as
 * `deal_logo`.
 */
export const buildProjectBasicsFormData = (values, logo) => {
    const formData = new FormData();
    formData.append("projectName", values.projectName.trim());
    formData.append("description", values.description.trim());
    formData.append("country_region", values.country_region);
    formData.append("sector", JSON.stringify(values.sector || []));
    LISTING_OPTIONS.forEach(({ value }) => {
        formData.append(value, String(Boolean(values.listings?.includes(value))));
    });
    if (logo) {
        formData.append("deal_logo", logo);
    }
    return formData;
};

/**
 * The project-record fields a Data Room needs: logo, name, description,
 * country, sector and listings. Rendered inside a parent antd Form.
 */
const ProjectBasicsFields = ({ onLogoChange, logoUrl = null }) => (
    <>
        <Form.Item label="Logo">
            <UploadAvatar setImgFile={onLogoChange} imgUrl={logoUrl} shape={true} />
        </Form.Item>

        <Form.Item
            label="Project name"
            name="projectName"
            rules={[{ required: true, whitespace: true, message: "Enter a project name" }]}
        >
            <Input placeholder="e.g. Swiss Ecosystem Data Room" />
        </Form.Item>

        <Form.Item
            label="Short description"
            name="description"
            rules={[{ required: true, whitespace: true, message: "Enter a short description" }]}
            extra="Shown on the project card in listings."
        >
            <Input.TextArea rows={3} maxLength={1000} showCount />
        </Form.Item>

        <div className="project-basics-row">
            <Form.Item
                label="Country/Region"
                name="country_region"
                rules={[{ required: true, message: "Pick a country or region" }]}
            >
                <Select
                    showSearch
                    options={countryOptions}
                    optionFilterProp="label"
                    placeholder="Select"
                />
            </Form.Item>

            <Form.Item label="Sector" name="sector">
                <Select
                    mode="multiple"
                    showSearch
                    options={sectorOptions}
                    optionFilterProp="label"
                    placeholder="Select"
                />
            </Form.Item>
        </div>

        <Form.Item label="List it under" name="listings">
            <Checkbox.Group options={LISTING_OPTIONS} className="project-basics-listings" />
        </Form.Item>
    </>
);

export default ProjectBasicsFields;
